import {useCallback, useState} from "react";
import * as rawSpeciesImages from '../assets/data/species-images-merged.json';
import {toRootRelativeImagePath} from "./imagePaths";

const baseSpeciesImages = Object.fromEntries(Object.entries(rawSpeciesImages).map(([taxonomicOrder, image]: [string, any]) => {
    return [taxonomicOrder, {
        ...image,
        thumb: toRootRelativeImagePath(image.thumb),
        medium: toRootRelativeImagePath(image.medium)
    }];
}));

export const useGetSpeciesImages = () => {
    const [speciesImages, setSpeciesImages] = useState<any>(baseSpeciesImages);

    const getSpeciesImages = useCallback((markers: any) => {
        if (!markers?.features?.length) {
            return;
        }

        if (!speciesImages) {
            setSpeciesImages(baseSpeciesImages);
        }
    }, [speciesImages]);

    return {
        speciesImages,
        getSpeciesImages
    }
}
